import React from 'react'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';

function TextAreaCustom({
    label, iconType, type, value, onChange, nameClass, withFiles, vcard
}) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    return (
        <>
            <div dir={langLocal === 'ar' ? "rtl" : "ltr"} style={{ width: "100%",display: "flex",flexDirection: "column"  }} >
                <p className={`p-input ${mode === 'dark' ? "darktext" : "lighttext"} ${langLocal === 'ar' ? "textAlignRight" : ""}`} >{translate(label)}</p>

                <textarea dir={langLocal === 'ar' ? "rtl" : "ltr"} style={
                    withFiles ? { height: '35.5px' } :
                        vcard ? { height: '200px' } : {}
                } className={` ${nameClass} ${mode === 'dark' ? "darktext" : "lighttext"}`} defaultValue={value} onChange={onChange} />
            </div>
        </>
    )
}

export default TextAreaCustom